import Common from '@/libs/common';
import type { WalkLeg } from '@/libs/journey/journeys';

/** « 240 m » to the nearest ten metres, « 1,2 km » from a kilometre on. */
export function formatWalkDistance(meters: number, locale: string): string {
  if (meters < 1000) {
    return new Intl.NumberFormat(locale, { style: 'unit', unit: 'meter' }).format(
      Math.round(meters / 10) * 10,
    );
  }
  return new Intl.NumberFormat(locale, { style: 'unit', unit: 'kilometer', maximumFractionDigits: 1 }).format(
    meters / 1000,
  );
}

/** « 12 min », or « ~ 12 min » while the walk is only estimated from the crow-fly distance. */
export function formatWalkDuration(leg: Pick<WalkLeg, 'duration' | 'estimated'>): string {
  const duration = Common.formatSec(leg.duration);
  return leg.estimated ? `~ ${duration}` : duration;
}
